import { render, staticRenderFns } from "./BrandedModal.vue?vue&type=template&id=5aad025e&"
import script from "./BrandedModal.vue?vue&type=script&lang=js&"
export * from "./BrandedModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandedModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports